import React from 'react';

const StateResults = (props) => {
  const searchResults = props.searchResults;
  const hasResults = searchResults && searchResults.nbHits !== 0;
  const nbHits = searchResults && searchResults.nbHits;

  return (
    <p className="search-results">
      <small>
        {!hasResults ? `(no results)` : ''}
        {hasResults && nbHits === 1 ? `(${nbHits} result)` : ''}
        {hasResults && nbHits > 1 ? `(${nbHits} results)` : ''}
      </small>
    </p>
  );
};

export default StateResults;
